import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 13: "Witaj w społeczności" - wyjaśnia po co tu jesteśmy, 3 kroki
 */
export const InstagramStoryShare13 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "180px 72px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Welcome */}
        <p
          style={{
            fontSize: "44px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 12px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          Skoro tu jesteś, to znaczy że
        </p>

        <h1
          style={{
            fontSize: "68px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 12px",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          masz dobre serduszko 💚
        </h1>

        <p
          style={{
            fontSize: "38px",
            fontWeight: 600,
            color: "#5A8A70",
            margin: "0 0 48px",
            textAlign: "center",
          }}
        >
          i kochasz zwierzaki 🐾
        </p>

        {/* Divider */}
        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", marginBottom: "40px" }} />

        {/* Question */}
        <p
          style={{
            fontSize: "48px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 36px",
            textAlign: "center",
          }}
        >
          Po co się tu zebraliśmy?
        </p>

        {/* Steps */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
            maxWidth: "920px",
            marginBottom: "32px",
          }}
        >
          {/* Step 1 */}
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "24px",
              padding: "28px 36px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontSize: "40px", fontWeight: 800, color: "#4E8A6E", lineHeight: 1 }}>1</span>
            <p style={{ fontSize: "32px", fontWeight: 700, color: "#2D5A3D", margin: 0, lineHeight: 1.35 }}>
              Wejdź na stronę i sprawdź
              <br />
              czego potrzebują schroniska
              <br />
              w Twojej okolicy
            </p>
          </div>

          {/* Step 2 */}
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "24px",
              padding: "28px 36px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontSize: "40px", fontWeight: 800, color: "#4E8A6E", lineHeight: 1 }}>2</span>
            <p style={{ fontSize: "32px", fontWeight: 700, color: "#2D5A3D", margin: 0, lineHeight: 1.35 }}>
              Uzupełnij schroniska, których
              <br />
              brakuje - albo prześlij im link,
              <br />
              żeby same mogły to zrobić
            </p>
          </div>

          {/* Step 3 - highlighted */}
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "24px",
              padding: "28px 36px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              border: "3px solid #4E8A6E",
            }}
          >
            <span style={{ fontSize: "40px", fontWeight: 800, color: "#4E8A6E", lineHeight: 1 }}>3</span>
            <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: 0, lineHeight: 1.35 }}>
              Zostań ze mną na tym koncie —
              <br />
              będę udostępniać zweryfikowane
              <br />
              pilne potrzeby schronisk 🐾
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
